/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import s from './s.module.less';
import dayjs from 'dayjs';
import { Alert, Button, Checkbox, DatePicker, Form, Input, Select, Tooltip } from 'antd';
import { IProvderAgreementSignFormData, Provider } from 'types/provider';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Meta, ServerMeta, TKlarityProgramItem, TKlarityProgramItemDetail, IProvderProgramSignInput } from 'types/common';
import { NOT_SUPPORT_PROGRAM_STATE } from 'constants/common';
import ProviderStore from 'store/Provider';
import { getProviderNameDisplay } from 'utils/provider';
import ConfigStatus from 'components/ConfigStatus';
import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields, SettingEnum } from 'types/enumerationData';
import { TEnrollKlarityProgram } from 'api/common';

type IProps = {
    isModal?: boolean;
    onAgreeButtonClickFlag?: {},
    allowStates?: ServerMeta[];
    onSuccessNext?: (submitData: TEnrollKlarityProgram) => void;
    data?: TKlarityProgramItemDetail;
};

const SignProgram = (props: IProps) => {
    const { isModal, allowStates, onAgreeButtonClickFlag, onSuccessNext, data } = props;
    const contractUrl = data?.contractUrl || 'https://saas-dev-jp.s3.ap-northeast-1.amazonaws.com/dev/630b05c1-6dd0-4c70-b626-414846619879.html';
    const [agreementForm] = Form.useForm<IProvderProgramSignInput>();
    const [checked, setChecked] = React.useState(false);
    const [showCheckTip, setShowCheckTip] = React.useState(false);
    const [date, setDate] = React.useState(dayjs().format('MM/DD/YYYY'));
    const [name, setName] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [checkoutLoading, setCheckoutLoading] = React.useState(false);
    const [iframeHeight, setIframeHeight] = React.useState(220);
    const [selectedStates, setSelectedStates] = React.useState<string[]>([]);
    const [allStates] = useGetSettingData(EnumFields.STATE);
    const [getProvider] = ProviderStore.useStore();
    const provider: Provider = getProvider('data') as Provider;
    const defaultName = getProviderNameDisplay(provider);

    const singleServiceStatus: 'default' | 'configing' | 'selected' = 'default';
    const programStatus: 'default' | 'configing' | 'selected' = 'configing';

    const notSupportStatesObject = (allStates as SettingEnum[])?.filter((item) => {
        const notSupportStates = data?.excludeState?.split(',') || [];
        return notSupportStates.indexOf(item.dictKey) !== -1;
    })?.map((item) => item.content);

    React.useEffect(() => {
        if (data && allowStates) {
            const notSupportStates = data?.excludeState?.split(',') || []; //NOT_SUPPORT_PROGRAM_STATE
            setSelectedStates(allowStates?.filter((item) => { return notSupportStates.indexOf(item.dictKey) === -1; }).map((st: ServerMeta) => st.dictKey) || []);
        }
    }, [allowStates, data]);

    React.useEffect(() => {
        if (defaultName) {
            setName(defaultName);
        }
    }, [defaultName]);

    const handleCheckBoxChange = (e: CheckboxChangeEvent) => {
        setChecked(e.target.checked);
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    };
    const handleDateChange = (e: any, dateString: string) => {
        setDate(dateString);
    };
    const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAddress(e.target.value);
    };

    React.useEffect(() => {
        handleFormFinish();
    }, [onAgreeButtonClickFlag]);

    const scrollIntoView = () => {
        try {
            // document.getElementsByClassName('ant-modal-body')[0].scrollTo({
            //     top: 0,
            //     behavior: 'smooth',
            // });
            document.getElementById('ks-form-content')?.scrollTo({
                top: 9999,
                behavior: 'smooth',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handleFormFinish = () => {
        if (!checked) {
            setShowCheckTip(true);
            scrollIntoView();
        } else {
            setShowCheckTip(false);
            agreementForm.validateFields().then((formData: IProvderProgramSignInput) => {
                // if (salesDetail?.linkUuid) {
                //     handleAgreementSubmit({
                //         ...formData,
                //         contractSignDate: formData.contractSignDate ? dayjs(formData.contractSignDate).format('MM/DD/YYYY') : dayjs().format('MM/DD/YYYY'),
                //         linkUuid: salesDetail.linkUuid,
                //     });
                // }
                onSuccessNext?.({
                    programId: data?.id || 0,
                    states: selectedStates?.join(',') || '',
                    contractSignName: formData.name,
                    contractSignDate: formData.date ? dayjs(formData.date).format('MM/DD/YYYY') : dayjs().format('MM/DD/YYYY'),
                    contractSignAddress: formData.address,
                });
            }).catch((e) => {
                scrollIntoView();
                console.error(e);
            });
        }
    };

    React.useEffect(() => {
        const isShowAva = document.getElementById('ava-tips');
        let height = window.document.body.clientHeight - 60 - 80 - 310;
        if (isShowAva) {
            height -= 70;
        }
        if (height < 120) {
            height = 120;
        }
        setIframeHeight(height);
    }, []);

    return (
        <div className={`${s.wrap} ${isModal ? s.wrapModal : ''}`}>
            <div className={s.title}>
                <span className={s.icon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
                        <path d="M18.2856 5.63867L18.3447 5.52042C18.7664 4.67614 19.4113 3.96272 20.2106 3.45741C21.0313 2.93791 21.9804 2.66357 22.954 2.66357C25.7935 2.66357 28.1032 4.97333 28.1032 7.81284C28.1032 9.89872 26.8561 11.7655 24.9263 12.5695L24.8057 12.62L24.3926 12.7666L24.1136 12.8313C23.7352 12.9188 23.3457 12.9629 22.954 12.9629C20.1144 12.9629 17.8047 10.6531 17.8047 7.81363C17.8047 7.30202 17.8804 6.79592 18.0286 6.30953L18.1113 6.03914L18.2848 5.63867H18.2856Z" fill="black" />
                        <path d="M20.7138 11.4955C20.7492 11.4955 20.7847 11.5049 20.8162 11.5231C20.9148 11.5798 20.9487 11.706 20.8919 11.8045L20.7682 12.0189L20.9723 12.1135C21.4642 12.3413 21.9869 12.4817 22.5277 12.5305L22.7523 12.551V11.9322C22.7523 11.8187 22.8446 11.7265 22.9581 11.7265C23.0716 11.7265 23.1638 11.8187 23.1638 11.9322V12.551L23.3885 12.5305C23.9293 12.4817 24.4527 12.3413 24.9439 12.1135L25.1488 12.0189L25.0251 11.8045C24.9683 11.7067 25.0022 11.5798 25.1007 11.5231C25.1323 11.5049 25.167 11.4955 25.2032 11.4955C25.2765 11.4955 25.3451 11.5349 25.3822 11.5987L25.5059 11.8124L25.6904 11.6815C26.1326 11.3686 26.515 10.9862 26.8279 10.544L26.958 10.3595L26.7444 10.2358C26.6458 10.179 26.6119 10.0529 26.6687 9.95432C26.7057 9.89047 26.7735 9.85106 26.8476 9.85106C26.8839 9.85106 26.9186 9.86051 26.9501 9.87865L27.1645 10.0024L27.2591 9.79824C27.487 9.30633 27.6273 8.78368 27.6762 8.24289L27.6967 8.01822H27.0778C26.9643 8.01822 26.8721 7.92599 26.8721 7.81247C26.8721 7.69896 26.9643 7.60673 27.0778 7.60673H27.6967L27.6762 7.38206C27.6273 6.84127 27.487 6.31783 27.2591 5.82671L27.1645 5.62254L26.9501 5.7463C26.9186 5.76443 26.8831 5.77389 26.8476 5.77389C26.7743 5.77389 26.7057 5.73448 26.6687 5.67063C26.6119 5.57209 26.6458 5.44596 26.7444 5.3892L26.958 5.26543L26.8271 5.08097C26.5142 4.63872 26.1318 4.25639 25.6896 3.94343L25.5051 3.81257L25.3814 4.0262C25.3443 4.09006 25.2765 4.12947 25.2024 4.12947C25.1662 4.12947 25.1315 4.12001 25.0999 4.10188C25.0014 4.04512 24.9675 3.91899 25.0243 3.82045L25.148 3.60682L24.9431 3.51222C24.4512 3.2844 23.9285 3.14408 23.3877 3.0952L23.1631 3.07471V3.69353C23.1631 3.80705 23.0708 3.89928 22.9573 3.89928C22.8438 3.89928 22.7516 3.80705 22.7516 3.69353V3.07471L22.5269 3.0952C21.9861 3.14408 21.4627 3.2844 20.9715 3.51222L20.7674 3.60682L20.8911 3.82124C20.9479 3.91978 20.914 4.04591 20.8155 4.10267C20.7839 4.1208 20.7485 4.13026 20.713 4.13026C20.6397 4.13026 20.5711 4.09084 20.534 4.02699L20.4103 3.81336L20.2258 3.94422C19.7836 4.25718 19.4012 4.63951 19.0883 5.08175L18.9574 5.26622L19.171 5.3892C19.2696 5.44596 19.3035 5.57209 19.2467 5.67063C19.2097 5.73448 19.1419 5.77389 19.0678 5.77389C19.0315 5.77389 18.9968 5.76443 18.9653 5.7463L18.7509 5.62254L18.6563 5.82671C18.4284 6.31862 18.2881 6.84127 18.2392 7.38206L18.2188 7.60673H18.8376C18.9511 7.60673 19.0433 7.69896 19.0433 7.81247C19.0433 7.92599 18.9511 8.01822 18.8376 8.01822H18.2188L18.2392 8.24289C18.2881 8.78368 18.4284 9.30633 18.6563 9.79824L18.7509 10.0024L18.9653 9.87865C18.9968 9.86051 19.0315 9.85106 19.0678 9.85106C19.1411 9.85106 19.2097 9.89047 19.2467 9.95432C19.3035 10.0529 19.2696 10.179 19.171 10.2358L18.9574 10.3587L19.0883 10.5432C19.4012 10.9854 19.7836 11.3678 20.2258 11.6807L20.4103 11.8116L20.534 11.598C20.5711 11.5341 20.6389 11.4947 20.713 11.4947L20.7138 11.4955Z" fill="#FFCD1A" />
                        <path d="M22.8933 8.53472C22.7797 8.53472 22.6875 8.44249 22.6875 8.32897V5.85761C22.6875 5.74409 22.7797 5.65186 22.8933 5.65186C23.0068 5.65186 23.099 5.74409 23.099 5.85761V8.12322H24.5408C24.6543 8.12322 24.7466 8.21545 24.7466 8.32897C24.7466 8.44249 24.6543 8.53472 24.5408 8.53472H22.8933Z" fill="black" />
                        <rect x="5.32812" y="6.40576" width="17.4635" height="19.3346" rx="1.87109" fill="#93C1F9" />
                        <path d="M17.8027 13.2663H10.6302L9.38281 11.0833L9.69466 10.4596C13.1874 7.4659 17.179 9.21225 18.7382 10.4596L19.0501 11.0833L17.8027 13.2663Z" fill="white" />
                        <path d="M22.9864 19.9734V23.3632C22.9864 24.5772 22.0018 25.5618 20.7878 25.5618H7.52673C6.31273 25.5618 5.32812 24.5772 5.32812 23.3632V8.60437C5.32812 7.39037 6.31273 6.40576 7.52673 6.40576H20.7878C22.0018 6.40576 22.9864 7.39037 22.9864 8.60437V15.0094" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M22.9844 17.6787V17.6961" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M10.5484 13.1682C10.6359 13.3251 10.8015 13.4221 10.9804 13.4221H17.3326C17.514 13.4221 17.6803 13.3227 17.767 13.1635L18.9045 11.0713C18.9779 10.9365 18.9455 10.7686 18.8273 10.6708C17.8774 9.88883 13.6977 6.8885 9.44477 10.6693C9.33204 10.7694 9.30287 10.9349 9.37618 11.0666L10.5476 13.1682H10.5484Z" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" />
                        <path d="M14.1562 10.5049V13.4216" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M11.4766 10.8989L12.1072 12.1602" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" strokeLinecap="round" />
                        <path d="M16.7635 10.8989L16.1328 12.1602" stroke="black" strokeWidth="0.472989" strokeMiterlimit="10" strokeLinecap="round" />
                    </svg>
                </span>
                <span>
                    {data?.specialtyName}
                </span>
                <span className={`${s.tTab} ${s.tTabActive}`}>
                    <ConfigStatus status={programStatus} />
                    Klarity select program
                </span>
                <span className={s.tTab}>
                    <ConfigStatus status={singleServiceStatus} />
                    Single service sessions
                </span>
            </div>
            <h3>Enroll in the Klarity Select  {data?.specialtyName} Program</h3>
            <h4>1. Select service states</h4>
            <div className={s.tips}>Place select the state where you'd like to offer this program in your practice. Please note that the following states are not yet available: {notSupportStatesObject?.join(', ')}</div>
            <div className={s.selectWrap}>
                <Select
                    mode="multiple"
                    placeholder="Please select"
                    value={selectedStates}
                    onChange={(val) => {
                        if (val && val.length === 0) {
                            return;
                        }
                        setSelectedStates(val);
                    }}
                    style={{ width: '100%' }}
                >
                    {
                        allowStates?.filter((item) => {
                            const notSupportStates = data?.excludeState?.split(',') || []; //NOT_SUPPORT_PROGRAM_STATE
                            return notSupportStates.indexOf(item.dictKey) === -1;
                        }).map((st: ServerMeta) => {
                            return (
                                <Select.Option key={st.dictKey} value={st.dictKey}>
                                    {st.content}
                                </Select.Option>
                            );
                        })
                    }
                </Select>
            </div>
            <h4>2. Review program compliance restrictions</h4>
            <div className={s.complainWrap}>
                <div className={s.cContent}>
                    <div className={s.cItem}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M4.29289 5.12297C4.68342 4.73245 5.31658 4.73245 5.70711 5.12297L10 9.41586L14.2929 5.12297C14.6834 4.73245 15.3166 4.73245 15.7071 5.12297C16.0976 5.5135 16.0976 6.14666 15.7071 6.53718L11.4142 10.8301L15.7071 15.123C16.0976 15.5135 16.0976 16.1467 15.7071 16.5372C15.3166 16.9277 14.6834 16.9277 14.2929 16.5372L10 12.2443L5.70711 16.5372C5.31658 16.9277 4.68342 16.9277 4.29289 16.5372C3.90237 16.1467 3.90237 15.5135 4.29289 15.123L8.58579 10.8301L4.29289 6.53718C3.90237 6.14666 3.90237 5.5135 4.29289 5.12297Z" fill="#EF4444" />
                        </svg>
                        <p>
                            Cannot prescribe medication to non-Klarity users through partner pharmacies.
                        </p>
                    </div>
                    <div className={s.cItem}>
                        <div style={{ flex: '0 0 20px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4.29289 5.12297C4.68342 4.73245 5.31658 4.73245 5.70711 5.12297L10 9.41586L14.2929 5.12297C14.6834 4.73245 15.3166 4.73245 15.7071 5.12297C16.0976 5.5135 16.0976 6.14666 15.7071 6.53718L11.4142 10.8301L15.7071 15.123C16.0976 15.5135 16.0976 16.1467 15.7071 16.5372C15.3166 16.9277 14.6834 16.9277 14.2929 16.5372L10 12.2443L5.70711 16.5372C5.31658 16.9277 4.68342 16.9277 4.29289 16.5372C3.90237 16.1467 3.90237 15.5135 4.29289 15.123L8.58579 10.8301L4.29289 6.53718C3.90237 6.14666 3.90237 5.5135 4.29289 5.12297Z" fill="#EF4444" />
                            </svg>
                        </div>
                        <div>
                            <p>Providers must adhere to the following dosage limit:</p>
                            <div className={s.cItemTitle}>Patients new to GLP-1 medications:</div>
                            <div className={s.cItemContent}>
                                <p>Month 1: Up to 0.25 mg weekly (10 units), typically provided as 0.5 ml of Semaglutide at 5 mg/ml (CA: 1x (1 mg/ml) 1 ml per month).</p>
                                <p>Month 2: Up to 0.5 mg weekly (20 units), typically provided as 0.5 ml of Semaglutide at 5 mg/ml (CA: 1x (2.5 mg/ml) 1 ml per month).</p>
                                <p>Month 3: Up to 1 mg weekly (40 units), typically provided as 1 ml of Semaglutide at 5 mg/ml (CA: 1x (2.5 mg/ml) 2 ml per month).</p>
                            </div>
                            <div className={s.cItemTitle}>Patients already on GLP-1 medications</div>
                            <div className={s.cItemContent}>
                                <p>Month 1-3: Up to 1.25 mg weekly (50 units), typically provided as 1 ml of Semaglutide at 5 mg/ml (CA: 1x (2.5 mg/ml) 2 ml per month).</p>
                            </div>
                            <div className={s.cItemTitle} style={{ marginBottom: '8px' }}>Post 3-month subscription</div>
                            {/* <div className={s.cItemContent}>
                                <p>Month 1-3: Up to 1.25 mg weekly (50 units), typically provided as 1 ml of Semaglutide at 5 mg/ml (CA: 1x (2.5 mg/ml) 2 ml per month).</p>
                            </div> */}
                            <p>Prescribing dosages that exceed these limits is not permitted.</p>
                        </div>
                    </div>
                    <div className={s.cItem}>
                        <div style={{ flex: '0 0 20px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4.29289 5.12297C4.68342 4.73245 5.31658 4.73245 5.70711 5.12297L10 9.41586L14.2929 5.12297C14.6834 4.73245 15.3166 4.73245 15.7071 5.12297C16.0976 5.5135 16.0976 6.14666 15.7071 6.53718L11.4142 10.8301L15.7071 15.123C16.0976 15.5135 16.0976 16.1467 15.7071 16.5372C15.3166 16.9277 14.6834 16.9277 14.2929 16.5372L10 12.2443L5.70711 16.5372C5.31658 16.9277 4.68342 16.9277 4.29289 16.5372C3.90237 16.1467 3.90237 15.5135 4.29289 15.123L8.58579 10.8301L4.29289 6.53718C3.90237 6.14666 3.90237 5.5135 4.29289 5.12297Z" fill="#EF4444" />
                            </svg>
                        </div>
                        <div>Medication cannot be prescribed before the patient makes a payment, otherwise the order will be canceled.</div>
                    </div>
                </div>
            </div>
            <h4>
                3. Review the agreement
            </h4>
            <div className={s.contentBox}>
                <div className={s.iframeWrap}>
                    <iframe style={{ minHeight: `${iframeHeight}px` }} className={s.iframe} title="overview" src={contractUrl} />
                    {/* <iframe className={s.iframe} title="overview" src={`https://docs.google.com/viewer?url=${contractUrl}&embedded=true`} /> */}
                </div>
                <div className={s.confirmBox} id="confirm-box">
                    <Checkbox checked={checked} className={s.checkbox} onChange={handleCheckBoxChange}>By checking this box, I agree to the terms outlined in the agreement.</Checkbox>
                    {!checked && showCheckTip && <Alert className={s.alertMessage} message="Please accept the agreement to proceed to the next step." type="error" showIcon />}
                    <Form
                        form={agreementForm}
                        layout="vertical"
                        onFinish={handleFormFinish}
                    >
                        <div className={s.formItems}>
                            <div className={s.formItem}>
                                <Form.Item
                                    label="Signature"
                                    name="name"
                                    style={{ marginBottom: '4px' }}
                                    validateFirst
                                    rules={[
                                        { required: true, message: 'This is a required field' },
                                    ]}
                                >
                                    <Input style={{ width: '100%' }} type="text" onChange={handleNameChange} placeholder="Type your name" />
                                </Form.Item>
                                <div className={s.signatureText}>{name}</div>
                            </div>
                            <div className={`${s.formItem} ${s.fromItemDate}`}>
                                <Form.Item
                                    label="Today’s date"
                                    name="date"
                                    style={{ marginBottom: '4px' }}
                                    validateFirst
                                    rules={[
                                        { required: true, message: 'This is a required field' },
                                    ]}
                                >
                                    <DatePicker style={{ width: '100%' }} format="MM/DD/YYYY" disabledDate={(current) => current && current > dayjs().endOf('day')} onChange={handleDateChange} />
                                </Form.Item>
                                <div className={s.signatureText}>{date}</div>
                            </div>
                            <div className={`${s.formItem} ${s.formItemAddress}`}>
                                <Form.Item
                                    label={
                                        <div className={s.formLabel}>Residential address
                                            <Tooltip
                                                overlayClassName={s.tipCard}
                                                overlayInnerStyle={{ padding: '12px' }}
                                                color="#FFFFFF"
                                                title={<div className={s.tipText}>Enter your official address to receive legal documents and critical updates for your practice and contract obligations.</div>}
                                            >
                                                <div className={s.questionMarkIcon} />
                                            </Tooltip>
                                        </div>
                                    }
                                    name="address"
                                    style={{ marginBottom: '4px' }}
                                    validateFirst
                                    rules={[
                                        { required: true, message: 'This is a required field' },
                                        // FormValidationHelper.validateNonChinese('Please do not enter Chinese'),
                                    ]}
                                >
                                    <Input style={{ width: '100%' }} type="text" placeholder="Type your address" onChange={handleAddressChange} />
                                </Form.Item>
                                <div className={s.signatureText}>{address}</div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default SignProgram;
